import { ListMenuItem } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { DeveloperBulkUpdatePageState, developerBulkUpdatePageRoute } from "../DeveloperBulkUpdatePage/DeveloperBulkUpdatePage";

export const useDeveloperListMenuItems = (props: { permission: Permission }) => {
  const navigate = useNavigate();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(developerBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as DeveloperBulkUpdatePageState,
        }),
    });

  return menuItems;
};
